<div class="modify-res-block">
  <div class="modify-res-header popupHeader header">
    <span> {{ rGuestBookMessages?.myReservation?.updateReservationsText || "Update Reservations" }} </span>
    <span class="close-dialog-icon close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </span>
  </div>

  <!--Update Reservation 4 Steps are added here-->

  <div class="modify-res-body">
    <app-loader *ngIf="loaderMsg" [loaderMsg]="loaderMsg"></app-loader>
    <!-- Step 1: Room Selection-->
    <app-room-selection [hidden]="!(currentStepCount === 1)" [currencyDet]="data?.currencyDetails" [data]="data"></app-room-selection>
    <!-- Step 2: Guest Details-->
    <app-guest-details *ngIf="currentStepCount === 2"></app-guest-details>
    <!-- Step 3: Payment Details-->
    <app-payment *ngIf="currentStepCount === 3" (loadStatus)="onPaymentSubmit($event)" [data]="data"></app-payment>
    <!-- Step 4: Compare Screen-->
    <app-compare-reservation [data]="data" *ngIf="currentStepCount === 4" [currencyDet]="data?.currencyDetails"></app-compare-reservation>
  </div>

  <div class="col-12 text-center modify-res-footer btn-area">
    <button
      mat-raised-button
      mat-button
      color="primary"
      [disabled]="currentStepCount === 1"
      class="btn-book"
      (click)="updateStepsNavigation(-1)">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i> {{ rGuestBookMessages?.myReservation?.previousButton || "Previous" }}
    </button>
    <!-- If last step changing the Next button text to Update Reservation-->
    <button mat-raised-button mat-button color="primary" class="btn-book rightBtn" (click)="updateStepsNavigation(1)">
      {{
        this.currentStepCount === this.maxStepCount
          ? rGuestBookMessages?.myReservation?.updateReservationButton || "Update Reservation"
          : rGuestBookMessages?.myReservation?.nextButton || "Next"
      }}
      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
    </button>
  </div>
</div>
